import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DaoService } from '../servicos/dao.service';
import { SortEvent, MessageService } from 'primeng/api';
import { HtmlRemovedorPipe } from '../pipes/html-removedor.pipe';

@Component({
  selector: 'app-lista-arquivos',
  templateUrl: './lista-arquivos.component.html',
  styleUrls: ['./lista-arquivos.component.css']
})
export class ListaArquivosComponent implements OnInit {

  constructor(private dao: DaoService, private messageService: MessageService) { }

  @Input("categoria")categoria:string = null;
  @Input("acao")acao:any;
  @Input("edicao")edicao:boolean = false;
  @Output("editar")teditar =new EventEmitter();
  @Output("excluir")texcluir =new EventEmitter();
  @Input('miniMode')mini: boolean = false;
  @Input('mostrarLinks')mlinks = false;
  @Input()linhas: number = 15;
  @Input()modo: string = '';

  arquivos:any;
  dados:any[];
  onReject:any;
  busca:any;
  ngOnInit() {
    
  }

  ngOnChanges(){
      this.carregarLista();
  }

  baixar(endereco,titulo,tipo){
    endereco = endereco.replace('http:','https:');
    console.log("baixando");
    var link = document.createElement('a');
    link.href = endereco;
    link.download = 'b'+titulo+'.'+tipo;
    link.dispatchEvent(new MouseEvent('click'));
  }

tr(str){
  if(!str)return'';
  str = (str+'').toLowerCase();
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
}

filtrar(){
  return new Promise((resolve, reject) => {
    let r = this.dados.filter(arq=>{
      if(this.tr(arq.dia).includes(this.tr(this.busca)))return arq;
      if(this.tr(arq.titulo).includes(this.tr(this.busca)))return arq;
      if(this.tr(arq.novaDescricao).includes(this.tr(this.busca)))return arq;
      
    });
    resolve(r);
  });
}

mudouFiltro(){
  console.log("mudou ", this.busca);
  if(this.busca && this.busca.length>2){
    console.log("Filtrando");
    this.filtrar().then(res=>{
      console.log("Terminou filtro", res,this.arquivos,this.busca);
      this.arquivos = res;
    });
  }

  if(this.busca.length==0){
    this.arquivos = this.dados;
  }
}

  definirArquivo(tipo:any){
    let arquivo:string = 'padrao.png';
      if(tipo=='doc')arquivo = 'doc.png';
      if(tipo=='docx')arquivo = 'docx.png';
      if(tipo=='jpeg')arquivo = 'jpeg.png';
      if(tipo=='jpg')arquivo = 'jpg.png';
      if(tipo=='pdf')arquivo = 'pdf.png';
      if(tipo=='xls')arquivo = 'xls.png';
      if(tipo=='xlsx')arquivo = 'xlsx.png';

      return arquivo;
  }

  rem = new HtmlRemovedorPipe();

decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}

  carregarLista(){
    console.log("Carrengando arquivos...",this.categoria);
    if(this.categoria){
      let dados = {categoria:this.categoria,edicao:this.edicao};
      this.dao.submeter(dados,"listarArquivos").then(result=>{
          this.dados = result.filter(ar=>{
            ar.imagemArquivo = this.definirArquivo(ar.tipo);
            ar.novaDescricao = this.decodeHtml(this.rem.transform(ar.descricao));
            return  ar;
          });
          console.log("Arquivos ",this.dados);
          this.arquivos = this.dados;
      });
    }
  }

  editarEquipamento(equip){
      //passar para o proximo componente
      this.teditar.emit(equip);
  }

  confirmarExclusao(evento){
    this.messageService.add({ key: 'myKey1', severity:'warn', summary: 'Exclusão de Arquivo', detail: evento});
  }

  excluir(identificador){
    // passar para o proximo componente
    this.texcluir.emit(identificador);
    this.messageService.clear('myKey1');
  }

  cancelar(){
    this.messageService.clear('myKey1');
  }




  customSort(event: SortEvent) {
    
    console.log('Entrou no SORT, Evento->',event);
    event.data.sort((data1, data2) => {
        let value1 = data1[event.multiSortMeta[0].field];
        let value2 = data2[event.multiSortMeta[0].field];
        let result = null;
        console.log('value1->',value1);
        console.log('value2->',value2);
        console.log('E Numerico?->',this.is_numeric(value1));
        //console.log('event.field ->',event.multiSortMeta[0].field);
        //console.log('Data1[event.field] ->',data1[event.field]);
        //console.log(data2);

        if (value1 == null && value2 != null)
            result = -1;
        else if (value1 != null && value2 == null)
            result = 1;
        else if (value1 == null && value2 == null)
            result = 0;
        else if (!this.is_numeric(value1) && !this.is_numeric(value2)){
          console.log("É STRING");
            result = value1.localeCompare(value2);
            console.log('resultado do ESTRING->',result);
        }else{
          console.log("É COMPARATIVO");
          result = (parseInt(value1) < parseInt(value2) ) ? -1 : (parseInt(value1) > parseInt(value2) ) ? 1 : 0;
        }
            
        console.log('resultado->',result);
        console.log('retornado->',event.order * result);
        return (event.multiSortMeta[0].order *result);
    });
}

is_numeric = function(obj){
  return !Array.isArray( obj ) && (obj - parseFloat( obj ) + 1) >= 0;
}

}
